export var EditMode;
(function (EditMode) {
    EditMode[EditMode["EDIT"] = 0] = "EDIT";
    EditMode[EditMode["CREATE"] = 1] = "CREATE";
})(EditMode || (EditMode = {}));
